import React from 'react';

const Card = ({ 
  children, 
  variant = 'default', 
  padding = 'md', 
  className = '',
  hover = false,
  ...props 
}) => {
  const baseStyles = {
    backgroundColor: 'var(--bg-primary)',
    borderRadius: 'var(--radius-lg)',
    boxShadow: 'var(--shadow-sm)',
    border: '1px solid var(--color-gray-200)',
    transition: 'all var(--transition-fast)',
    overflow: 'hidden'
  };

  const variants = {
    default: {
      ...baseStyles
    },
    elevated: {
      ...baseStyles,
      boxShadow: 'var(--shadow-lg)',
      border: 'none'
    },
    outlined: {
      ...baseStyles,
      boxShadow: 'none',
      border: '1px solid var(--color-gray-300)'
    },
    filled: {
      ...baseStyles,
      backgroundColor: 'var(--color-gray-50)',
      border: 'none',
      boxShadow: 'none'
    }
  };

  const paddings = {
    none: { padding: 0 },
    sm: { padding: 'var(--space-4)' },
    md: { padding: 'var(--space-6)' },
    lg: { padding: 'var(--space-8)' },
    xl: { padding: 'var(--space-10)' }
  };

  const cardStyles = {
    ...variants[variant],
    ...paddings[padding],
    ...(hover && {
      '&:hover': {
        boxShadow: 'var(--shadow-md)',
        transform: 'translateY(-2px)'
      }
    }),
    ...props.style
  };

  return (
    <div
      {...props}
      style={cardStyles}
      className={className}
    >
      {children}
    </div>
  );
};

const CardHeader = ({ children, className = '', ...props }) => (
  <div
    {...props}
    className={className}
    style={{
      paddingBottom: 'var(--space-4)',
      borderBottom: '1px solid var(--color-gray-200)',
      marginBottom: 'var(--space-4)'
    }}
  >
    {children}
  </div>
);

const CardTitle = ({ children, className = '', ...props }) => (
  <h3
    {...props}
    className={className}
    style={{
      fontSize: 'var(--font-size-lg)',
      fontWeight: 'var(--font-weight-semibold)',
      color: 'var(--color-gray-900)',
      margin: 0
    }}
  >
    {children}
  </h3>
);

const CardDescription = ({ children, className = '', ...props }) => (
  <p
    {...props}
    className={className}
    style={{
      fontSize: 'var(--font-size-sm)',
      color: 'var(--color-gray-600)',
      margin: 'var(--space-1) 0 0 0'
    }}
  >
    {children}
  </p>
);

const CardContent = ({ children, className = '', ...props }) => (
  <div
    {...props}
    className={className}
    style={{ marginBottom: 'var(--space-4)' }}
  >
    {children}
  </div>
);

const CardFooter = ({ children, className = '', ...props }) => (
  <div
    {...props}
    className={className}
    style={{
      paddingTop: 'var(--space-4)',
      borderTop: '1px solid var(--color-gray-200)',
      marginTop: 'var(--space-4)'
    }}
  >
    {children}
  </div>
);

Card.Header = CardHeader;
Card.Title = CardTitle;
Card.Description = CardDescription;
Card.Content = CardContent;
Card.Footer = CardFooter;

export default Card;
